import request from '../axios/axios';

/**
 * get请求模板
 */
export const Get = (path: string, params: any) => {
    return request.post(path, params);
};
/**
 * post请求模板
 */
export const Post = (path: string, params: any) => {
    return request.post(path, params);
};